var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.168,
    height: 35.411,
    viewBox: "0 0 22.168 35.411",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desk-microphone-svgrepo-com",
    transform: "translate(-90.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6075",
    "data-name": "Group 6075",
    transform: "translate(90.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26510",
    "data-name": "Path 26510",
    d: "M147.071,16.38v3.289a3.96,3.96,0,0,0,3.96,3.96h5.94a3.96,3.96,0,0,0,3.96-3.96V16.38h-4.95V13.41h4.95V8.877h-4.95V5.907h4.95V3.96A3.96,3.96,0,0,0,156.972,0h-5.94a3.96,3.96,0,0,0-3.96,3.96V5.907h4.95v2.97h-4.95V13.41h4.95v2.97h-4.95Z",
    transform: "translate(-142.912)",
    fill: "#d6c1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26511",
    "data-name": "Path 26511",
    d: "M90.335,286.369a7.764,7.764,0,0,0,7.3,6.231h2.306v4.6H97.068v2.97h8.713V297.2h-2.871v-4.6h2.305c3.6,0,6.533-3.143,7.288-6.181l-2.883-.715c-.47,1.9-2.353,3.927-4.4,3.927H97.634a4.876,4.876,0,0,1-4.393-3.877Z",
    transform: "translate(-90.335 -264.76)",
    fill: "#d6c1a5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesk);
export default __webpack_public_path__ + "static/media/Desk.16fa98d8c9292038dce4256a8da884b6.svg";
export { ForwardRef as ReactComponent };